import { Button } from '../features/button'
import * as C from './styles'
export const Header = ()=>{
    return(
        <C.Header>
            <div className='header__text'>
                <h3>Hello, i am</h3>
                <h1><strong>Willian Souza</strong></h1>
                <h3>A fullStack developer</h3>
            </div>
            <div className='header__buttons'>
                <Button text='Dolowoad CV'  onclickHandle={()=>window.open("https://drive.google.com/file/d/10J33P0bEVbvdnUKtqWz6Slx9I0dBeKty/view?usp=sharing")}/>
                <Button primary text='Contact' onclickHandle={()=>window.open("https://wa.me/qr/H2IO4ZE3XXLDK1")}/>
            </div>
        </C.Header>
    )
}